import Vue from "vue";
import Vuetify from "vuetify/lib";
// import { preset } from "vue-cli-plugin-vuetify-preset-shrine/preset";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
// don't forget to import CSS styles
import "tiptap-vuetify/dist/main.css";
// Vuetify's CSS styles
// import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const options = {};

const vuetify = new Vuetify({
  // preset,
  options,
  theme: {
    themes: {
      light: {
        primary: "#3f82a4",
      },
    },
  },
});

Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: "mdi",
});

export default vuetify;
